import { ExtensionApi } from './api/extension';

const APIs = [ExtensionApi];

export const ApiFactory = {
    create: function (options, eventBus) {
        const collection = {};

        return APIs.reduce((col, Api) => {
            const instance = new Api(options, eventBus);
            col[instance.constructor.name.toLowerCase()] = instance;
            return col;
        }, collection);
    }
};